$(document).ready(function() {
  // Function to move "Premium Gift Packaging" option
  function movePremiumGiftPackaging() {
    // Find the element containing "Premium Gift Packaging"
    const $premiumGiftPackagingTitle = $('.bold_option_title').filter(function() {
      return $(this).text().trim() === 'Premium Gift Packaging';
    });

    if ($premiumGiftPackagingTitle.length > 0) {
      // Get the parent 'bold_option_set' of the 'Premium Gift Packaging'
      const $premiumGiftPackagingSet = $premiumGiftPackagingTitle.closest('.bold_option_set');

      if ($premiumGiftPackagingSet.length > 0) {
        // Detach the 'bold_option_set' element
        $premiumGiftPackagingSet.detach();

        // Find the container of all 'bold_option_set' elements
        const $boldOptionsContainer = $('.bold_options');

        if ($boldOptionsContainer.length > 0) {
          // Find the 'bold_option_total' element
          const $boldOptionTotal = $boldOptionsContainer.find('.bold_option_total');

          if ($boldOptionTotal.length > 0) {
            // Insert the 'Premium Gift Packaging' option before 'bold_option_total'
            $premiumGiftPackagingSet.insertBefore($boldOptionTotal);
          } else {
            // Append the 'Premium Gift Packaging' option at the end if 'bold_option_total' is not present
            $boldOptionsContainer.append($premiumGiftPackagingSet);
          }
        }
      }
    }
  }

  // Function to prepend "Add thin rhodium rounded box chain" option
  function prependRhodiumBoxChain() {
    // Find the element containing "Add thin rhodium rounded box chain"
    const $rhodiumBoxChainTitle = $('.bold_option_title').filter(function() {
      return $(this).text().trim() === 'Add thin rhodium rounded box chain 1.3mm';
    });

    if ($rhodiumBoxChainTitle.length > 0) {
      // Get the parent 'bold_option_set' of the 'Add thin rhodium rounded box chain'
      const $rhodiumBoxChainSet = $rhodiumBoxChainTitle.closest('.bold_option_set');

      if ($rhodiumBoxChainSet.length > 0) {
        // Detach the 'bold_option_set' element
        $rhodiumBoxChainSet.detach();

        // Find the container of all 'bold_option_set' elements
        const $boldOptionsContainer = $('.bold_options');

        if ($boldOptionsContainer.length > 0) {
          // Prepend the 'Add thin rhodium rounded box chain' option to the container
          $boldOptionsContainer.prepend($rhodiumBoxChainSet);
        }
      }
    }
  }

  // Call the functions
  setTimeout(()=>{
    // movePremiumGiftPackaging();
    prependRhodiumBoxChain();
  },1000)
    
});